function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2018",
  "data-name": "Grupo 2018",
  transform: "translate(-70.547 -69.748)"
}, /*#__PURE__*/React.createElement("g", {
  id: "LOTTO"
}, /*#__PURE__*/React.createElement("g", {
  id: "_6",
  "data-name": 6
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1227",
  "data-name": "Caminho 1227",
  d: "M75,87.833l.136,1.1,4.415-.542-.136-1.1Zm1.717-6.559a2.427,2.427,0,0,0-1.279.523,2.333,2.333,0,0,0-.735,1.137,3.945,3.945,0,0,0-.1,1.632,3.269,3.269,0,0,0,.88,2.044,2.185,2.185,0,0,0,1.851.528,2.148,2.148,0,0,0,1-.377,1.832,1.832,0,0,0,.626-.788,2.183,2.183,0,0,0-.21-1.979,1.693,1.693,0,0,0-.693-.589,1.657,1.657,0,0,0-.9-.131,1.6,1.6,0,0,0-.67.234,1.225,1.225,0,0,0-.443.469,2.051,2.051,0,0,1,.184-1.11.886.886,0,0,1,.7-.452,1.973,1.973,0,0,1,.663.046,3.2,3.2,0,0,1,.768.3l.332-1.108a2.487,2.487,0,0,0-.91-.345A3.514,3.514,0,0,0,76.713,81.274Zm.393,4.733a.646.646,0,0,1-.533-.152.914.914,0,0,1-.137-1.113.656.656,0,0,1,.48-.272.643.643,0,0,1,.531.144.95.95,0,0,1,.134,1.122.641.641,0,0,1-.476.271Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "_45",
  "data-name": 45
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1228",
  "data-name": "Caminho 1228",
  d: "M92.465,87.8l.132,1.182a2.484,2.484,0,0,0,1.008-.055,3.9,3.9,0,0,0,1.077-.423,2.991,2.991,0,0,0,.965-.842,1.912,1.912,0,0,0,.365-1.028,1.967,1.967,0,0,0-.283-1.076,2.023,2.023,0,0,0-.7-.741,1.7,1.7,0,0,0-.912-.247,2.189,2.189,0,0,0-1.6.82L92,84.5l2.075-1.2-.582-1.009L90.119,84.24l1.752,3.034.733-.423a2.158,2.158,0,0,1,.325-.434,1.8,1.8,0,0,1,.4-.323,1,1,0,0,1,.68-.155.739.739,0,0,1,.5.392.731.731,0,0,1,.1.625,1.073,1.073,0,0,1-.508.511A2.838,2.838,0,0,1,92.465,87.8Zm-4.7-2.2-.408,4.59.57.987,2.061-1.19.5.864,1.3-.75-.5-.864.667-.386-.586-1.016-.668.386-1.869-3.238ZM89.4,88.974l-.871.5.145-1.76.725,1.256Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "_18",
  "data-name": 18
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1229",
  "data-name": "Caminho 1229",
  d: "M86.571,73.349a1.767,1.767,0,0,0-1.109-.015.94.94,0,0,0-.6.655.977.977,0,0,0,0,.574.934.934,0,0,0,.339.46.944.944,0,0,0-.6.177,1,1,0,0,0-.351.545.98.98,0,0,0,.174.924,2.338,2.338,0,0,0,2.215.636.982.982,0,0,0,.637-.692A.93.93,0,0,0,86.85,75.5a.862.862,0,0,0,.52-.2.985.985,0,0,0,.31-.5.94.94,0,0,0-.159-.873A1.772,1.772,0,0,0,86.571,73.349ZM81.3,75.183l-.227.795,2.645.758.228-.794-.822-.236L84,72.664l-.706-.2-1.514.367.153.822.754-.185-.561,1.955Zm4.359,1.338c-.394-.113-.552-.313-.471-.6s.32-.367.715-.254.552.313.471.6-.321.368-.715.255Zm.461-1.606a.6.6,0,0,1-.337-.2.4.4,0,0,1-.031-.345.385.385,0,0,1,.208-.273.776.776,0,0,1,.73.209.386.386,0,0,1,.031.342.393.393,0,0,1-.209.276.589.589,0,0,1-.393-.006Z",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2021",
  "data-name": "Grupo 2021"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1230",
  "data-name": "Caminho 1230",
  d: "M91.25,94.248a7.011,7.011,0,0,1-1.821-.242,6.933,6.933,0,1,1,1.821.242Zm0-13.718a6.775,6.775,0,0,0-.941.065,6.743,6.743,0,1,0,4.3,12.519h0a6.681,6.681,0,0,0,2.008-1.771A6.745,6.745,0,0,0,91.25,80.53Z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2022",
  "data-name": "Grupo 2022"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1231",
  "data-name": "Caminho 1231",
  d: "M77.133,91.034a6.086,6.086,0,1,1,6.087-6.087A6.094,6.094,0,0,1,77.133,91.034Zm0-11.944a5.857,5.857,0,1,0,5.857,5.857A5.864,5.864,0,0,0,77.133,79.09Z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2023",
  "data-name": "Grupo 2023"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1232",
  "data-name": "Caminho 1232",
  d: "M84.483,79.894a4.823,4.823,0,1,1,4.823-4.823A4.828,4.828,0,0,1,84.483,79.894Zm0-9.416a4.594,4.594,0,1,0,4.593,4.593A4.6,4.6,0,0,0,84.483,70.478Z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
})));

function SvgLottoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.167,
    height: 25,
    viewBox: "0 0 28.167 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLottoIcon);
export default __webpack_public_path__ + "static/media/lotto-icon.5eb70816.svg";
export { ForwardRef as ReactComponent };